import './WhatAreYouLookingFor.css';
import stopEventPropagation from '../ui_core/stopEventPropagation';
import PropertyBindingFactory from '../mvvm/PropertyBindingFactory';
import numberWithCommas from '../core/numberWithCommas';
import IconButtonNonReact from '../components/IconButtonNonReact';
import Dialog from '../components/Dialog';
import Urls from '../urls/Urls';
import Feature from '../enums/Feature';
export default class WhatAreYouLookingForFirstOptions{
	constructor({nBeds, price, houseType, features, whatAreYouLookingForViewModel}){
		this._whatAreYouLookingForViewModel = whatAreYouLookingForViewModel;
		this._element = document.createElement('div');
		this._element.classList.add('first-options');
		this._createButton= this._createButton.bind(this);
		this._clickedNext= this._clickedNext.bind(this);
		this._getPriceRangeText= this._getPriceRangeText.bind(this);
		this._setNextEnabled= this._setNextEnabled.bind(this);
		this._plotsStillAvailableChanged= this._plotsStillAvailableChanged.bind(this);
		this.collapseExpandedOptions= this.collapseExpandedOptions.bind(this);
		this._formatNumberToString = this._formatNumberToString.bind(this);
		this._handleBack = this._handleBack.bind(this);
		this._get_show= this._get_show.bind(this);
		this._buttonBedsElement = this._createButton('Beds', 'n-beds-button', this._get_show('n-beds-visible'),
			'nBedrooms', (nBedrooms)=>nBedrooms?String(nBedrooms):'');
		this._buttonPriceElement = this._createButton('Price', 'price-button', 
			this._get_show('price-visible', price.becomingVisible), 'priceRange',
			this._getPriceRangeText);
		this._buttonFeaturesElement = this._createButton('Features', 'features-button', this._get_show('features-visible'),
			'features', (features)=>features?features.map(feature=>feature.name).join(','):'');
		this._buttonHousetypeElement = this._createButton('Housetype', 'housetype-button', 
			this._get_show('housetype-visible'), 'houseTypes', 
			(houseTypeViewModels)=>houseTypeViewModels?houseTypeViewModels.map(houseTypeViewModel=>houseTypeViewModel.name).join(','):'');
		this._nBeds = nBeds;
		this._Price = price;
		this._houseType = houseType;
		this._features = features;
		nBeds.addEventListener('chose', this.collapseExpandedOptions);
		price.addEventListener('chose', this.collapseExpandedOptions);
		features.addEventListener('chose', this.collapseExpandedOptions);
		houseType.addEventListener('chose', this.collapseExpandedOptions);
		this._buttonBedsElement.appendChild(this._nBeds.element);
		this._buttonPriceElement.appendChild(this._Price.element);
		this._buttonFeaturesElement.appendChild(this._features.element);
		this._buttonHousetypeElement.appendChild(this._houseType.element);
		const buttonNextTitleElement = document.createElement('div');
		buttonNextTitleElement.classList.add('title');
		buttonNextTitleElement.innerHTML = "Find my Home";
		this._buttonNext = document.createElement('button');
		this._buttonNext.classList.add('button-next');
		this._buttonNext.classList.add('option-button');
		this._buttonNext.appendChild(buttonNextTitleElement);
		this._buttonNext.addEventListener('click', this._clickedNext);
		this._element.appendChild(this._buttonNext);
		this._propertyBindingPlotsStillAvailable = PropertyBindingFactory.standard(this,
		whatAreYouLookingForViewModel,
		'plotsStillAvailable', this._plotsStillAvailableChanged);
	}
	_plotsStillAvailableChanged(value){
		this._plotsStillAvailable = value;
		this._nextEnabled = this._whatAreYouLookingForViewModel.hasFilterApplied;
		this._setNextEnabled(this._nextEnabled);
	}
	_setNextEnabled(value){
		if(value)
			this._buttonNext.classList.add('enabled');
		else this._buttonNext.classList.remove('enabled');
	}
	_clickedNext(){
		if(!this._nextEnabled)return;
		this._whatAreYouLookingForViewModel.visible = false;
		this._whatAreYouLookingForViewModel.setFilterInSite();
	}
	_handleBack(){
		this.collapseExpandedOptions();
	}
	_getPriceRangeText(priceRange){
		if(!priceRange)return '';
		const [priceFrom, priceTo] = priceRange;
		const hasPriceFrom=priceFrom!==undefined&&priceFrom!==null;
		const hasPriceTo=priceTo!==undefined&&priceTo!==null;
		if(hasPriceFrom){
			if(!hasPriceTo)
				return `from ${this._formatNumberToString(priceFrom)}`;
			return `${this._formatNumberToString(priceFrom)} - ${this._formatNumberToString(priceTo)}`;
		}
		return `to ${this._formatNumberToString(priceTo)}`;
	}
	_formatNumberToString(value){
		if(value===undefined||value===null)return value;
		let str = String(value);
		str = str.split('.')[0];
		return numberWithCommas(str);
	}
	collapseExpandedOptions(){
		if(this._currentCssClassNameShow){
			this._element.classList.remove(this._currentCssClassNameShow);
			this._currentCssClassNameShow = null;
		}
		this._element.classList.remove('has-visible');
	}
	_get_show(cssClassNameShow, becomingVisible){
		return ()=>{
			this.collapseExpandedOptions();
			this._element.classList.add('has-visible');
			this._element.classList.add(cssClassNameShow);
			this._currentCssClassNameShow = cssClassNameShow;
			becomingVisible&&becomingVisible();
		};
	}
	_createButton(buttonText, cssClassName, onClick, propertyName, getTextFromValue){
		const buttonElement = document.createElement('button');
		buttonElement.classList.add('option-button');
		buttonElement.classList.add(cssClassName);
		const titleElement = document.createElement('div');
		titleElement.classList.add('title');
		buttonElement.addEventListener('click', onClick);
		buttonElement.appendChild(titleElement);
		const buttonBackElement = 
		this._iconButtonBack = new IconButtonNonReact({
			className:"button-back",
			imgUrl:Urls.assets+'icons/back.png',
			onClick:this._handleBack,
			stopEventPropagation:true});
		stopEventPropagation(this._iconButtonBack.element, ['click', 'mousedown', 'touchstart']);
		titleElement.appendChild(this._iconButtonBack.element);
		const titleTextElement = document.createElement('div');
		titleTextElement.classList.add('text');
		titleTextElement.innerHTML = buttonText;
		titleElement.appendChild(titleTextElement);
		this._element.appendChild(buttonElement);
		PropertyBindingFactory.standard(this, this._whatAreYouLookingForViewModel, propertyName, 
			(value)=>{
				let text = getTextFromValue(value);
				if(text!=='')
					text=`(${text})`;
				titleTextElement.innerHTML = `${buttonText} ${text}`;
		});
		return buttonElement;
	}
	get element(){
		return this._element;
	}
}